import { $get } from '@/utils/http';

const getList = (params = {}) => $get({ url: '/operation/smart/common/getexportlist', params }); // 下载列表数据
const getLoginInfo = (params = {}) => $get({ url: '/smart/web/account/getlogininfo', params }); // 登录信息
const getMyAuth = (params = {}) => $get({ url: '/smart/web/auth/getmyauth', params }); // 我的权限
// const getLogout = (params = {}) => $get({ url: '/smart/web/account/logout', params }); // 退出登录
const getImportList = (params = {}) =>
  $get({ url: '/operation/smart/common/getimportlist', params }); // 上传列表
const getImportNewsNum = (params = {}) =>
  $get({ url: '/operation/smart/common/getimportnewsnum', params }); // 获取上传列表未读消息数
const getExportNewsNum = (params = {}) =>
  $get({ url: '/operation/smart/common/getexportnewsnum', params }); // 获取下载列表未读消息数
const getProjectList = (params = {}) =>
  $get({ url: '/operation/smart/common/getprojectlist', params }); // 获取项目列表
const getBasicData = (params = {}) =>
  $get({ url: '/smart/web/salaryparameterdetail/getSalaryParameterDetailByEnglishField', params }); // 获取项目列表

export default {
  getList,
  getLoginInfo,
  getMyAuth,
  // getLogout,
  getImportList,
  getImportNewsNum,
  getExportNewsNum,
  getProjectList,
  getBasicData, // 枚举类型啥的都放在里面
};
